import UibookCase from 'uibook/case'
import React from 'react'
import TelegramBadge from '../TelegramBadge'

const MODES = ['primary', 'critical', 'secondary', 'gray', 'white']

const I18N = {
  ru: {
    label: {
      primary: 'Primary',
      critical: 'Critical',
      secondary: 'Secondary',
      gray: 'Gray',
      white: 'White',
    },
    hint: {
      primary: 'Основной статус.',
      critical: 'Критический статус.',
      secondary: 'Вторичный статус.',
      gray: 'Нейтральный статус.',
      white: 'Светлый статус для темного фона.',
    }
  },
  en: {
    label: {
      primary: 'Primary',
      critical: 'Critical',
      secondary: 'Secondary',
      gray: 'Gray',
      white: 'White',
    },
    hint: {
      primary: 'Primary status color.',
      critical: 'Critical status color.',
      secondary: 'Secondary status color.',
      gray: 'Neutral status color.',
      white: 'Light status style for dark surfaces.',
    }
  }
}

export default {
  background: 'light',
  component: TelegramBadge,
  i18n: true,
  cases: MODES.map(mode => locale => <UibookCase props={{
    type: 'number',
    mode: mode,
    value: '9',
    label: I18N[locale].label[mode],
    description: I18N.en.hint[mode]
  }}></UibookCase>)
}
